import React, { FunctionComponent } from 'react';
import { StockStatus } from '../../../models/common/stock.model';
import styles from './stock-status-card-component.module.scss';

type StockStatusCardProps = {
  stockStatus: StockStatus;
  title: string;
  stockMessage?: string;
  infoMessage?: string;
  noMobileBorderRadius?: boolean;
};

export const StockStatusCard: FunctionComponent<StockStatusCardProps> = (props: StockStatusCardProps) => {
  return (
    <div className={styles['stock-status-container']}>
      <div
        className={`${styles['stock-status-info']} ${styles[props.stockStatus.toLowerCase() ?? '']} ${
          props.noMobileBorderRadius ? styles['no-mobile-border-radius'] : ''
        }`}>
        <p className={styles.status} dangerouslySetInnerHTML={{ __html: props.title }} />
        {props.stockMessage && props.stockMessage.trim() !== '' && (
          <p
            className={styles['status-info']}
            dangerouslySetInnerHTML={{
              __html: props.stockMessage,
            }}
          />
        )}
      </div>

      {props.infoMessage && <p className={styles.help} dangerouslySetInnerHTML={{ __html: props.infoMessage }}></p>}
    </div>
  );
};

export default StockStatusCard;
